/*
=============================================
Author      : <ยุทธภูมิ ตวันนา>
Create date : <๒๑/๐๒/๒๕๖๓>
Modify date : <๑๑/๐๙/๒๕๖๗>
Description : <>
=============================================
*/

'use strict';

import { Component, OnInit, ContentChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DeviceDetectorService } from 'ngx-device-detector';

import { AppService } from '../../app.service';
import { AuthService, UserInfo } from '../../auth.service';
import { DataService, Schema } from '../../data.service';
import { ProjectService } from '../project.service';

@Component({
    selector: 'app-project-home',
    templateUrl: './project-home.component.html',
    styleUrls: ['./project-home.component.scss'],
    providers: [
        ProjectService,
        DecimalPipe
    ]
})

export class ProjectHomeComponent implements OnInit {
    @ContentChild('ProjectHomeView', { static: false }) ProjectHomeView: any;

    data: any = {
        projectCategory$: null
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private modal: NgbModal,
        private deviceService: DeviceDetectorService,
        private appService: AppService,
        private authService: AuthService,
        private dataService: DataService,
        private projectService: ProjectService
    ) {
    }

    ngOnInit(): void {
        this.data.projectCategory$ = this.route.snapshot.data.projectCategory$;
        this.searchFilter.doReset();
    }

    searchFilter = {
        that: this,
        formField: {
            keyword: null,
            projectCategory: {
                set: {
                    pc1: null,
                    pc2: null
                }
            },
            registrationStatus: {},
            userType: {}
        },
        doReset(): void {
            this.that.route.queryParams.subscribe((param: any) => {
                this.formField.keyword = (param.query !== undefined && param.query.length > 0 ? param.query : null);
                this.formField.projectCategory.set.pc1 = (param.category !== undefined && param.category.length > 0 ? param.category.toUpperCase() : 'ALL');
                this.formField.projectCategory.set.pc2 = this.formField.projectCategory.set.pc1;

                if (param.status !== undefined &&
                    param.status.length > 0) {
                    let registrationStatuses: Array<string> = (param.status).split('|');

                    registrationStatuses.forEach((registrationStatus: string) => {
                        registrationStatus = registrationStatus.toUpperCase();
                        this.formField.registrationStatus[registrationStatus] = true;
                    });
                }

                if (param.type !== undefined &&
                    param.type.length > 0) {
                    let userTypes: Array<string> = (param.type).split('|');

                    userTypes.forEach((userType: string) => {
                        this.formField.userType[userType] = true;
                    });
                }
                else {
                    let userInfo: UserInfo = this.that.authService.getUserInfo;

                    if (userInfo !== null &&
                        userInfo.type !== undefined)
                        this.formField.userType[userInfo.type] = true;
                }

                this.doAction();
            });
        },
        doAction(): void {
            this.that.projectService.operate.table.service.keyword = this.formField.keyword;
            this.that.projectService.operate.table.service.projectCategory = this.formField.projectCategory.set.pc1;

            let registrationStatuses: Array<string> = [];
            this.that.dataService.registrationStatus.data$.forEach((registrationStatus: Schema.Statuses) => {
                if (this.formField.registrationStatus[registrationStatus.ID] === true)
                    registrationStatuses.push(registrationStatus.ID);
            });
            this.that.projectService.operate.table.service.registrationStatuses = registrationStatuses;

            let userTypes: Array<string> = [];
            this.that.dataService.userTypes.data$.forEach((userType: Schema.Statuses) => {
                if (this.formField.userType[userType.ID] === true)
                    userTypes.push(userType.ID);
            });
            this.that.projectService.operate.table.service.userTypes = userTypes;

            this.that.route.queryParams.subscribe((param: any) => {
                let url: string = this.that.router.createUrlTree([], {
                    relativeTo: this.that.route,
                    queryParams: {
                        query: (this.formField.keyword !== null && this.formField.keyword.length > 0 ? this.formField.keyword : undefined),
                        category: this.formField.projectCategory.set.pc1,
                        status: (registrationStatuses.length > 0 ? registrationStatuses.join('|').toString() : undefined),
                        type: (userTypes.length > 0 ? userTypes.join('|').toString() : undefined)
                    }
                }).toString();
                window.history.replaceState('', '', ("#" + url));
            });
        }
    }
}
